import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { actionCreators } from '@/store/Notifications'
import Resx from '@/components/Resx'
import { Link } from 'react-router-dom'
import { Scrollbar } from '@/components/scrollbar'
import { Button } from '@/components/button'
import LoadingIndicator from '@/components/LoadingIndicator'
import ErrorBoundary from '@/components/ErrorBoundary'
import { NotificationItem } from '@/components/notifications/notificationItem'

class Notifications extends React.Component {
    static propTypes = {
      className: PropTypes.string
    };

    componentDidMount () {
      this.props.loadNotifications()
    }

    render () {
      const { className, items, retrieving } = this.props
      if (retrieving && !items.length) {
        return <LoadingIndicator />
      }
      if (!items.length) {
        return (
          <ErrorBoundary>
            <div className='d-notification__nothing'><Resx name='NotificationsUI.NoNotifications' /></div>
            <div className='d-notification__more'><Link className='underline' to='/notifications' onClick={this.onNavigate}><Resx name='NotificationsUI.NotificationList' /></Link></div>
          </ErrorBoundary>
        )
      }
      return (
        <ErrorBoundary>
          <div className={className}>
            <Scrollbar>
              <div style={{ maxHeight: 250 }}>{items.map(item => <NotificationItem menuNotifications={this.props.menuNotifications} isSingleNotification={items.length === 1} key={item.id} {...item} onRead={this.onReadClick} onNavigate={this.props.onNavigate} />)}</div>
            </Scrollbar>
          </div>
          <div className='d-notification__more'><Link className='underline' to='/notifications' onClick={this.onNavigate}><Resx name='NotificationsUI.NotificationList' /></Link></div>
        </ErrorBoundary>
      )
    }

    onReadClick = e => {
      const { id, state } = e
      this.props.updateState(id, state)
    };

    onNavigate = () => {
      if (typeof this.props.onNavigate === 'function') this.props.onNavigate()
    }
}

class NotificationsMore extends React.Component {
    static propTypes = {
      className: PropTypes.string
    };

    scroll = () => {
      if (
        this.props.itemsMore.length < this.props.count &&
        window.innerHeight + document.documentElement.scrollTop >= document.documentElement.offsetHeight - 200
      ) {
        this.props.loadMoreNotifications(this.props.page + 1)
      }
    }

    componentDidUpdate (prevProps) {
      if (this.props.itemsMore.length !== prevProps.itemsMore.length) this.scroll()
    }

    componentDidMount () {
      document.addEventListener('scroll', this.scroll)
      this.props.loadMoreNotifications(0)
    }

    componentWillUnmount () {
      document.removeEventListener('scroll', this.scroll)
      this.props.notificationsClear()
    }

    render () {
      const { className, itemsMore, count, retrievingFull } = this.props
      if (retrievingFull && !itemsMore.length) {
        return <LoadingIndicator />
      }
      if (!itemsMore.length) {
        return (
          <React.Fragment>
            <div className='d-notification__nothing'><Resx name='NotificationsUI.NoNotifications' /></div>
          </React.Fragment>
        )
      }
      return (
        <React.Fragment>
          <div className={className}>
            {itemsMore.map(item => <NotificationItem isSingleNotification={itemsMore.length === 1} key={item.id} {...item} onRead={this.onReadClick} />)}
          </div>
          {itemsMore.length < count ? (
            <div className='d-notification__more'>{retrievingFull ? <LoadingIndicator inline /> : <Button onClick={this.onMoreClick}><Resx name='Common.More' /></Button>}</div>
          ) : null}

        </React.Fragment>
      )
    }

    onReadClick = e => {
      const { id, state } = e
      this.props.updateState(id, state)
    };

    onMoreClick = () => {
      this.props.loadMoreNotifications(this.props.page + 1)
    }
}

function mapStateToProps (state) {
  return {
    items: state.notifications.notifications || [],
    itemsMore: state.notifications.notificationsFull || [],
    count: state.notifications.userNotificationCount || 0,
    page: state.notifications.page,
    retrieving: state.notifications.retrieving,
    retrievingFull: state.notifications.retrievingFull
  }
}

const mapDispatchToProps = {
  updateState: actionCreators.updateState,
  clearState: actionCreators.clearState,
  loadNotifications: actionCreators.loadNotifications,
  loadMoreNotifications: actionCreators.loadMoreNotifications,
  notificationsClear: actionCreators.notificationsClear
}

const NotificationsWithMore = connect(mapStateToProps, mapDispatchToProps)(NotificationsMore)

export {
  NotificationsWithMore
}
export default connect(mapStateToProps, mapDispatchToProps)(Notifications)



// WEBPACK FOOTER //
// ./src/components/notifications/Notifications.js